import React from 'react';

const TituloTexto = (props) => {
  return (
    <div className='row'>
      <div className='col-lg-12'>
        <h3 className='titulo-sin-espacio'>{props.titulo}</h3>
        <p>
          {props.texto}
        </p>
      </div>
    </div>
  );
};

export default TituloTexto;
